import axiosInstance from "../../api/axios";

const ValidationService = {
  /**
   * @param {{ deep?: boolean, toleranceRevenue?: string, auditLimit?: number }} options
   */
  getOverview: async (options = {}) => {
    const params = new URLSearchParams();
    if (options.deep) {
      params.set("deep", "1");
    }
    if (options.refresh) {
      params.set("refresh", "1");
    }
    if (options.toleranceRevenue) {
      params.set("tolerance_revenue", options.toleranceRevenue);
    }
    if (options.auditLimit) {
      params.set("audit_limit", String(options.auditLimit));
    }

    const query = params.toString();
    const url = query ? `/monitoring/validation?${query}` : "/monitoring/validation";
    const response = await axiosInstance.get(url, {
      timeout: options.deep ? 600000 : 90000,
    });
    return response.data;
  },

  remediate: async (action, options = {}) => {
    const response = await axiosInstance.post(
      "/monitoring/validation/remediate",
      {
        action,
        dry_run: options.dryRun ?? false,
        income_id: options.incomeId ?? undefined,
      },
      { timeout: 600000 }
    );
    return response.data;
  },
};

export default ValidationService;
